import { c as _c } from "react/compiler-runtime";
import { useTourCardRating } from "@website/accommodation-ui/tour-card/tour-card-hotel-rating/hooks";
import { TourCardRatingProperties } from "@website/accommodation-ui/tour-card/tour-card-hotel-rating/types";
import { MaterialIcon } from "@website/icons/material";
import { MiniChips } from "@website/ui/mini-chips";
import { FC } from "react";
export const TourCardRating: FC<TourCardRatingProperties> = properties => {
  const $ = _c(4);
  const {
    shouldRender,
    badgeColor,
    badgeText
  } = useTourCardRating(properties);
  let t0;
  if ($[0] !== badgeColor || $[1] !== badgeText || $[2] !== shouldRender) {
    t0 = shouldRender ? <MiniChips StartIcon={<MaterialIcon className="text-base" name="stars" />} className={`p-1 !font-medium ${badgeColor === "warning" ? "bg-[#EBA8251A] fill-[#EBA8251A] text-[#EBA825]" : ""}`} color={badgeColor} size="medium" text={badgeText} variant="accent" /> : null;
    $[0] = badgeColor;
    $[1] = badgeText;
    $[2] = shouldRender;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return t0;
};